import * as Utils from "../libraries/utils.js";
import * as mutationTypes from "../store/mutation-types";
import { getDeliveryMethodByNumberValue } from "../domains2/libraries/DeliveryMethods";

export function processGBOKioskCategoryElementsModel(
	elements,
	elementsInGroupAmount = 3,
	productCatalog,
	deliveryChoice,
	globalSelectedShopId
) {
	const convertedArr = [];

	const isProductEnabled = (productId) => {
		const product = productCatalog.getProduct(productId);
		if (!product) {
			return false;
		}

		if (!Utils.isProductAllowedToProceed({ product })) {
			return false;
		}
		if (!product.isActive) {
			return false;
		}

		if (product.options.deliveryMethodIndex) {
			if (!product.options.deliveryMethodIndex.includes(deliveryChoice)) {
				return false;
			}
		}
		if (!Utils.isProductAvailableForChannel(product)) {
			return false;
		}
		// check if one of its single subproducts is disabled
		const singleSubProducts = product.groups
			.filter((g) => g.appearance === "single")
			.map((group) => productCatalog.getProduct(group.options.defaultSelected, true));
		if (singleSubProducts.some(subProduct => !subProduct.isActive)) {
			return false;
		}
		if (Array.isArray(product.assortmentRules) && product.assortmentRules.length && globalSelectedShopId) {
			const forbiddenShop = product.assortmentRules.find(rule => rule.shopId === globalSelectedShopId);
			return forbiddenShop === undefined;
		}

		return true;
	};

	const convertProductsToGridBlocks = (products) => {
		const gridBlocks = [
			{
				items: [],
				objType: "GridBlockElement",
				template: "T3c",
				editingState: false
			}
		];
		products.forEach((productId) => {
			const lastBlock = gridBlocks[gridBlocks.length - 1];
			lastBlock.items.push({
				id_ref: productId
			});
			const activeItemsInLastBLock = lastBlock.items.filter(
				(item) => productCatalog ? isProductEnabled(item.id_ref) : true
			);
			elementsInGroupAmount = products.length;
			if (activeItemsInLastBLock.length === elementsInGroupAmount) {
				gridBlocks.push({
					items: [],
					objType: "GridBlockElement",
					template: "T3c",
					editingState: false
				});
			}
		});
		return gridBlocks;
	};
	elements.forEach((element) => {
		const products = element.props ? element.props.products : [];
		const subCategoryName = element.props ? element.props.subCategoryName : "";
		if (products && products.length) {
			const gridBlocks = convertProductsToGridBlocks(products);
			if (subCategoryName) {
				convertedArr.push({
					name: subCategoryName,
					objType: "SectionHeaderElement",
					gridBlocks,
					editingState: false
				});
			}
			convertedArr.push(...gridBlocks);
		}
	});
	return convertedArr;
}

export async function generateProductCatalog(shopId, deliveryMethod, store, shopNumber = null) {
	const getShops = async () => {
		if (store.getters.featureToggles.useNewShopsData) {
			return Promise.all([store.dispatch(mutationTypes.FETCH_AND_CACHE_SHOPS, { forceRefresh: true })]);
		}
		return Promise.all([
			store.dispatch(mutationTypes.FETCH_AND_CACHE_SHOPS, { forceRefresh: true }),
			store.dispatch(mutationTypes.FETCH_AND_CACHE_PICKUP_RULES, {})
		]);
	};
	const [shops] = await getShops();
	// in some cases shopId is not provided, but shopNumber
	const shop = shops.find(s => s.id === shopId || s.shopNumber === shopNumber);
	if(!shop || !shop.enabled) {
		store.commit(
			mutationTypes.SET_GLOBAL_INFO_DIALOG,
			"shopComponents.gt2.shoppingCart_steps.shoppingCartStepPickupTime.shopClosed"
		);
		return false;
	}
	await store.dispatch("setGlobalSelectedShop", {
		...shop,
		submitted: true,
		shopAddress: `
				${shop.shopAddress.street},
				${shop.shopAddress.zip}
				${shop.shopAddress.city}`,
		shopStreet: shop.shopAddress.street,
		shopCityAndZip: `
				${shop.shopAddress.zip}
				${shop.shopAddress.city}
		`});
	if (store.getters.featureToggles.useNewProductCatalog) {
		await store.commit(mutationTypes.SET_TENANT_SPECIFIC_DATA, {
			key: "deliveryChoice",
			value: deliveryMethod
		});
		const deliveryMethodRef = getDeliveryMethodByNumberValue(deliveryMethod);
		await store.dispatch("refreshProductCatalog", {
			deliveryMethod: deliveryMethodRef,
			invalidateCache: true
		});
	}
	await store.dispatch(mutationTypes.ADD_ORDER_TAGS_BASED_ON_PICKUP_OPTION);
	return true;
}
